import React, { useEffect, useState, useRef } from "react";
import Modal from "@mui/material/Modal";
import { useSelector, useDispatch } from "react-redux";
import { handleTogglePrintContrat } from "../../../store/slice/contrat/Contrat.js";
import Box from "@mui/material/Box";
import { IoPrint } from "react-icons/io5";
import { useReactToPrint } from "react-to-print";
// import Button from "@mui/material/Button";
// import Stack from "@mui/material/Stack";
const ParagrapheSectionFacture = ({ libelle, styleParagraphe }) => {
  return <p className={styleParagraphe ? styleParagraphe : null}>{libelle}</p>;
};
export const SectionFacture = ({
  DataParagaphe,
  styleName,
  isConteneurDiv,
  DataParagapheDiv,
}) => {
  return (
    <section className={styleName}>
      {isConteneurDiv && (
        <div>
          {DataParagapheDiv.map((item, index) => (
            <ParagrapheSectionFacture
              styleParagraphe={item.styleParagraphe}
              key={index}
              libelle={item.libelle}
            />
          ))}
        </div>
      )}

      {!isConteneurDiv && (
        <>
          {DataParagaphe.map((item, index) => (
            <ParagrapheSectionFacture
              styleParagraphe={item.styleParagraphe}
              key={index}
              libelle={item.libelle}
            />
          ))}
        </>
      )}
    </section>
  );
};
export default function PrintModalContrat({}) {
  const dispatch = useDispatch();
  const isShowModalPrintContrat = useSelector(
    (state) => state.contratsReducer.togglePrintContrat
  );
  const printRef = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  return (
    <div>
      <Modal
        open={isShowModalPrintContrat}
        onClose={() => dispatch(handleTogglePrintContrat(false))}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            overflow: "auto",
            height: 500,
            bgcolor: "background.paper",
            border: "1px solid #000",
            boxShadow: 24,
            borderRadius: "10px",
            padding: "2em",
          }}>
          <h5>Imprimer le contrat</h5>
          <div ref={printRef} className="px-4">
            <SectionFacture
              styleName={"d-flex justify-content-between align-items-center"}
              DataParagaphe={[
                {
                  libelle: "REF:C/.../.../PDG/APRIM",
                },
                // {
                //   libelle: `Abidjan, le ${dayjs().format("DD/MM/YYYY")}`,
                // },
              ]}
            />
            <SectionFacture
              styleName={"d-flex justify-content-end my-5"}
              isConteneurDiv
              DataParagapheDiv={[
                {
                  libelle: "A",
                },
                // {
                //   libelle: `${nom} ${prenom}`,
                // },
                // {
                //   libelle: phone,
                // },
                {
                  libelle: " ABIDJAN",
                },
              ]}
            />
            <SectionFacture
              styleName={"d-flex justify-content-center"}
              DataParagaphe={
                [
                  // {
                  //   libelle: `FACTURE PROFORM : ${reference}`,
                  //   styleParagraphe:
                  //     "w-50 border border-2 border-primary rounded p-2 text-center",
                  // },
                ]
              }
            />
            <SectionFacture
              styleName={"d-flex justify-content-center my-2"}
              DataParagaphe={[
                {
                  libelle: `Contrat`,
                  styleParagraphe:
                    "border border-5 border-dark text-center px-2",
                },
              ]}
            />

            {/* <SectionFacture
              styleName={"d-flex justify-content-end my-5"}
              DataParagaphe={[
                {
                  libelle: `TITRE DU RESPONSABLE DE L’AGENCE`,
                  styleParagraphe: "h3",
                },
              ]}
            /> */}
            {/* <SectionFacture
              styleName={"d-flex justify-content-end my-5"}
              DataParagaphe={[
                {
                  libelle: `NOM DU RESPONSABLE`,
                  styleParagraphe: "h3",
                },
              ]}
            /> */}
          </div>
          <section className="d-flex justify-content-end">
            <span>Imprimer le contrat</span>
            <IoPrint
              fontSize={"2em"}
              style={{ cursor: "pointer" }}
              onClick={() => handlePrint()}
            />
          </section>
        </Box>
      </Modal>
    </div>
  );
}
